import { useRouterState } from "@tanstack/react-router";
import { lastmodFor } from "@/lib/route-lastmod";

interface LastUpdatedProps {
  /** Override the date (YYYY-MM-DD). Defaults to the current route's content date. */
  date?: string;
  /** Spanish label, for /es pages. */
  lang?: "en" | "es";
  className?: string;
}

const formatDate = (iso: string, lang: "en" | "es") => {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(Date.UTC(y, (m ?? 1) - 1, d ?? 1)).toLocaleDateString(
    lang === "es" ? "es-ES" : "en-US",
    { year: "numeric", month: "long", day: "numeric", timeZone: "UTC" },
  );
};

/**
 * Visible "Last updated" line. Uses the same page-specific content date the
 * sitemap publishes as <lastmod>, so what readers see matches what crawlers get.
 */
export function LastUpdated({ date, lang = "en", className = "" }: LastUpdatedProps) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const iso = date ?? lastmodFor(pathname);
  if (!iso) return null;

  return (
    <p className={`text-sm text-muted-foreground ${className}`.trim()}>
      {lang === "es" ? "Última actualización: " : "Last updated: "}
      <time dateTime={iso}>{formatDate(iso, lang)}</time>
    </p>
  );
}

export default LastUpdated;
